import { baseInstance } from "@/config/instance";
import { onParseResponse } from "@/utils/axiosUtil";
import axios from "axios";

export const getUsersAPI = async (params) => {
  const response = await onParseResponse({
    method: "get",
    url: `/api/users`,
    params,
  });

  return response;
};

export const getCurrentUserAPI = async (payload) => {
  console.log("API Payload:", payload);

  try {
    // Make the direct API call without onParseResponse
    const response = await onParseResponse({
      method: "post",
      url: `/api/users/me`,
      data: payload,
    });
    console.log("Raw API Response:", response);
    return response;
  } catch (error) {
    console.error("Full error object:", error);
    throw error;
  }
};

export const checkEmailExistsAPI = async (data) => {
  const response = await onParseResponse({
    method: "post",
    url: `/api/users/check-email`,
    data,
  });

  return response;
};

export const getUserByIdAPI = async (id) => {
  const response = await onParseResponse({
    method: "get",
    url: `/api/users/${id}`,
  });

  return response;
};

export const createUserAPI = async (data) => {
  const response = await onParseResponse({
    method: "post",
    url: `/api/users`,
    data,
  });

  return response;
};

export const updateUserAPI = async (id, data) => {
  const response = await onParseResponse({
    method: "put",
    url: `/api/users/${id}`,
    data,
  });

  return response;
};

export const deleteUserAPI = async (id) => {
  const response = await onParseResponse({
    method: "delete",
    url: `/api/users/${id}`,
  });

  return response;
};

export const signUpUserAPI = async (values) => {
  try {
    const formData = new FormData();
    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName);
    formData.append("email", values.email);
    formData.append("country", values.country);
    formData.append("zipCode", values.zipCode);
    formData.append("howDidYouHear", values.howDidYouHear);
    formData.append("referrerName", values.referrerName);
    formData.append("referrerEmail", values.referrerEmail);
    formData.append("otherDetails", values.otherDetails);
    formData.append("resumeFile", values.resumeFile);
    formData.append("documentReferrer", values.documentReferrer);

    const response = await axios({
      method: "post",
      url: "/api/users/signup",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data; // Return just the data, not the whole response
  } catch (error) {
    // If the server returned an error response, return that data
    if (error.response?.data) {
      return error.response.data;
    }
    // If it's a network error, throw it to be caught by the component
    throw error;
  }
};

export const createUserCareerPathAPI = async () => {
  const response = await onParseResponse({
    method: "patch",
    url: `/api/users/careers`,
  });
  return response;
};

export const getUserCareerPathAPI = async () => {
  const response = await onParseResponse({
    method: "get",
    url: `/api/users/careers`,
  });
  return response;
};

export const downloadCareerDetailsAPI = async (id) => {
  return await onParseResponse({
    method: "post",
    url: `/api/users/careers`,
    data: { id },
  });
};

export const regenerateUserCareerPathAPI = async () => {
  console.log("Regenerating career path");
  const response = await onParseResponse({
    method: "post",
    url: `/api/users/careers/regenerate`,
  });
  return response;
};
